import { useEffect } from 'react';

const useHopscotch = () => {
  useEffect(() => {
    if (typeof window === 'undefined') return;

    // Skip if Hopscotch is already initialized
    if ((window as any).Hopscotch && (window as any).Hopscotch) return;

    // Define Hopscotch queue function if not already defined
    (window as any).Hopscotch =
      (window as any).Hopscotch ||
      function () {
        ((window as any).Hopscotch.q = (window as any).Hopscotch.q || []).push(arguments);
      };

    // Create container div
    const elm = document.createElement('div');
    elm.setAttribute('data-widget-host', 'hopscotch');
    elm.setAttribute('data-props-api-key', '3a87cf2d-49bd-4fac-bd2b-3b300453fc94');
    document.body.appendChild(elm);

    // Load external script
    const script = document.createElement('script');
    script.id = 'hopscotch-script';
    script.src = 'https://app.hopscotch.club/widget.js?';
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);

    // Cleanup on unmount
    return () => {
      document.body.removeChild(elm);
      document.body.removeChild(script);
    };
  }, []);
};

export default useHopscotch;
